import type { ExclusionAreaObservation } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapCollection } from '../normalize'

export const getByExclusionArea = async ({
  exclusionAreaId,
  signal,
}: {
  exclusionAreaId: string
  signal?: AbortSignal
}): Promise<ExclusionAreaObservation[]> => {
  const response = await apiClient.get(endpoints.v2.exclusionAreas.observations(exclusionAreaId), {
    signal,
  })
  return unwrapCollection<ExclusionAreaObservation>(response)
}
